  <template>
    <div>
      <b-tr v-for="section in topologyItem.Sections" :key="section.SectionId">
        <b-form-checkbox class="ml-3" :style="'padding-left:' + paddingLeft + 'rem'" v-model="section.Download" @change="setDownload(section, section.Download)">
          <h6>
            {{ section.DisplayName ? section.Displayname : 'Default Section Table' }}
            <span class="smaller float-md-right mx-2"><b-badge style="font-size: 10px">Section</b-badge></span>
          </h6>
        </b-form-checkbox>
        <div :style="'padding-left:' + paddingLeft + 'rem'">
          <b-button variant="link" v-b-toggle="'collapse' + section.SectionId">
            Tabs
            <b-icon icon="chevron-down" aria-hidden="true"></b-icon>
          </b-button>
        </div>
        <b-collapse :id="'collapse' + section.SectionId" class="mt-2">
          <tabs
            :topologyItem="section" :paddingLeft="paddingLeft + 2" @checkParent="checkParent" />
        </b-collapse>
      </b-tr>
    </div>
  </template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Tabs from './tabs.vue'

@Component({
  components: {
    'tabs': Tabs,
  },
})

export default class extends Mixins() {
  @Prop()
  public topologyItem!: any

  @Prop()
  public paddingLeft!: number

  public checkParent() {
    this.topologyItem.Download = true
    this.$emit('checkParent')
  }

  public setDownload(item: any, value: boolean) {
    if (value) {
      this.checkParent()
    }
    item.Tabs?.forEach((t) => {
      t.Download = value
      t.Tables?.forEach((ta) => {
        ta.Download = value
      })
    })
  }
}
</script>
